import React, { useContext, useState } from 'react';
import { Header, Footer, Tab } from 'components';
import { BaseWrapper, Background } from '../../styles';
import { Test1Container } from './styles';
import { Route, useRouteMatch, Switch, Redirect } from 'react-router-dom';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { Button, Button2, Surface } from 'components';
import { Field, Form, Formik, FieldArray } from 'formik';
import {
  InputField,
  Label,
  MultiSelectField,
  Section,
  SectionHeader,
  SectionLegend,
  SectionTitle,
  SelectField
} from 'components/Form';
import { Col, Row } from 'components/Grid';
import { ButtonContainer } from './styles';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { FitinsurAPI, MessageCenter }from 'utils';

export default function Test1Page() {

  console.log("LoginPage - BEGIN");

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const [ loginState, setLoginState ] = useState(authContext.status);
  const [ loginMessage, setLoginMessage ] = useState(authContext.status==true ? "Authenticated user ("+authContext.username+")" : "User not authenticated");  

  const match = useRouteMatch();

  const history = useHistory();

  const goToListPage = () => {
    history.push('list');
  };  

  const goToQuotePage = () => {
    //mc.error("goToNextPage");
    history.push('quote');
  };      

  const goToLoginPage = () => {
    //mc.error("goToNextPage");
    history.push('login');
  };      

    return (
    <BaseWrapper>
      <Background />
      <Test1Container>

        <Header title="Test1" subtitle="Please enter your Test1 information"></Header>

        <Formik
          initialValues = { {
            field1: '',
            field2: '',
          } }

          validationSchema = { Yup.object({
            field1: Yup.string().required('* Required field'),
            field2: Yup.string().required('* Required field')
          }) }

          onSubmit = { values => { 
            
            loading.start();

            console.log("onSubmit - BEGIN");

            setTimeout(()=>{
              
              const fitinsur = new FitinsurAPI();
const mc = new MessageCenter();

              goToLoginPage();
  
              loading.stop();        
            },1000);

            
            console.log("onSubmit - END");
          } }
        >

          { (props) => ( 
            <Form>
              <Surface>
                <Section>
                
                <SectionHeader justifyContent="space-between">
                  <SectionTitle>Dados Form Test1</SectionTitle>
                  <SectionLegend>
                    Required fields are signed with *
                  </SectionLegend>
                </SectionHeader>

                  <Row>
                    <Col  xs={12} md={12}>
                      <Field 
                        name="field1" 
                        label="Field1" 
                        type="text" 
                        component={InputField}
                        isRequired
                        disabled={ loginState==true }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col  xs={12} md={6}>
                      <Field
                        name="field2"
                        label="Field2"
                        type="text"
                        component={InputField}
                        isRequired
                        disabled={ loginState==true }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={6}>
                      <SectionLegend>Test1 Status: OK</SectionLegend>
                    </Col>
                    <Col xs={12} md={6}>
                      <ButtonContainer>
                        <Button 
                          primary type="button" 
                          id="btnBack" 
                          onClick={ goToLoginPage() }
                          disabled={ loginState!==true }>
                          Logout
                        </Button>                
                        <Button 
                          primary type="submit" 
                          id="btnLogin" 
                          style={ { } }
                          disabled={ loginState==true }>
                          Login
                        </Button>
                      </ButtonContainer>                  
                    </Col>
                    
                  </Row>                  
                </Section>
              </Surface>

            </Form>
          ) }

        </Formik>

        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </Test1Container>      
      <Footer />
    </BaseWrapper>

  );
}
